import clsx from "clsx";
import shape from "../../assets/img/shapes/bee-shape-02.webp";


const BeeShape02 = ( props:any ) => {

    return (
        <div className={clsx("rmdr-bee-shape-02", props.className)}>
            <img src={shape} alt="rmdr-bee-shape-02" loading="lazy" width={107} height={107} />
        </div>
    )

}

export default BeeShape02;
